
import Dinero from 'dinero.js'
import Vue from 'vue'

import Ability from '@/ability'
import Router from '@/router'
import Store from '@/store'

import MyAdelya from '@/plugins/myAdelya'

import App from '@/App.vue'
import AppFavorite from '@/AppFavorite.vue'
import Login from '@/Login.vue'
import MyAccount from '@/MyAccount.vue'
import ProductLogin from '@/ProductLogin.vue'
import Site from '@/Site.vue'

(() => {

  const APP_SELECTOR = '#app';
  const LOGIN_SELECTOR = '.appLogin';
  const MY_ADELYA = '.appMyAdelya';
  const PRODUCT_FAVORITE_SELECTOR = '.appFavorite';
  const PRODUCT_LOGIN_SELECTOR = '.appProductLogin';
  const SITE_SELECTOR = '.appSite';

  // Configuration
  Dinero.defaultCurrency = 'EUR'
  Dinero.defaultPrecision = 2
  Dinero.globalLocale = 'fr-FR'
  Vue.config.productionTip = false

  // Plugins
  Vue.use(MyAdelya, Store)

  // Error handler
  let errorHandler = function(error) {
    console.error('💥 Une erreur est survenue dans l\'application : ' + error.message)
    console.error(error)
    this.$error()
    return false
  }

  // Application
  if ( document.querySelector(APP_SELECTOR) !== null ) {
    new Vue({
      ability: Ability,
      router: Router,
      store: Store,
      errorCaptured: errorHandler,
      render: h => h(App)
    }).$mount(APP_SELECTOR)

    console.log('🚀 Wepapp Adelya démarrée')
  }

  // Favorite
  if ( document.querySelector(PRODUCT_FAVORITE_SELECTOR) !== null ) {
    document.querySelectorAll(PRODUCT_FAVORITE_SELECTOR).forEach(root => {
      new Vue({
        ability: Ability,
        store: Store,
        errorCaptured: errorHandler,
        render: h => h(AppFavorite)
      }).$mount(root)
    });

    console.log('❤️ Favoris Adelya démarrés')
  }

  // Login
  if ( document.querySelector(LOGIN_SELECTOR) !== null ) {
    document.querySelectorAll(LOGIN_SELECTOR).forEach(root => {
      new Vue({
        ability: Ability,
        store: Store,
        errorCaptured: errorHandler,
        render: h => h(Login)
      }).$mount(root)
    });

    console.log('🖼️ Modale de connexion démarrée')
  }

  if ( document.querySelector(PRODUCT_LOGIN_SELECTOR) !== null ) {
    document.querySelectorAll(PRODUCT_LOGIN_SELECTOR).forEach(root => {
      new Vue({
        ability: Ability,
        store: Store,
        errorCaptured: errorHandler,
        render: h => h(ProductLogin)
      }).$mount(root)
    });

    console.log('📦 Modale de connexion produit démarrée')
  }

  // Site
  if ( document.querySelector(SITE_SELECTOR) !== null ) {
    document.querySelectorAll(SITE_SELECTOR).forEach(root => {
      new Vue({
        ability: Ability,
        store: Store,
        errorCaptured: errorHandler,
        render: h => h(Site)
      }).$mount(root)
    });

    console.log('🖼️ Modale de sélection client / site démarrée')
  }

  // Mon Compte
  if ( document.querySelector(MY_ADELYA) !== null ) {
    document.querySelectorAll(MY_ADELYA).forEach(root => {
      new Vue({
        ability: Ability,
        store: Store,
        errorCaptured: errorHandler,
        render: h => h(MyAccount)
      }).$mount(root)
    });

    console.log('🔗 Accès Mon Compte démarré')
  }

})()
